<template>
  <header :class="{ header: 1, bright: bright }">
    <button class="open-menu" @click="toggleMenu">
      <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1.75h23m-23 8h23m-23 8.5h23" stroke="" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
    <button class="btn btn--secondary" @click="() => talkToRepresentative()">דברו איתי</button>
    <transition name="drop">
      <nav class="nav" v-if="!isMobile || isMenuActive">
        <div class="nav__top">
          <button class="close-menu" @click="toggleMenu">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L21 21M21 1L1 21" stroke="#fff" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
          <div class="mobile-logo">
            <svg width="40" height="30" viewBox="0 0 40 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M28.203 1.778h-2.087l-5.119 7.16.023.012 1.032 1.439M35.699 1.778h-2.087L24.766 14.16l1.043 1.456 9.89-13.84zM31.953 1.778h-2.092l-6.98 9.766 1.05 1.462 8.022-11.228zM27.588 18.095 39.246 1.777h-1.89L26.645 16.772l.945 1.323z"
                fill="#FBC02D" />
              <path
                d="m12.185 1.778 13.531 18.939 1.05-1.461L14.277 1.778h-2.093zM4.69 1.778 21.97 25.96l1.044-1.46L6.782 1.777H4.69zM8.44 1.778l15.403 21.56 1.044-1.46-14.36-20.1H8.44zM1.142 1.778l19.055 26.666.945-1.322L3.037 1.778H1.142z"
                fill="#fff" />
            </svg>
          </div>
        </div>
        <ul>
          <li class="nav__item" v-for="step in steps" :key="step.step">
            <a href="#" class="nav__link" :class="{ active: step.active }" @click="($event) => setStep(step, $event)">{{
              step.text
            }}</a>
          </li>
        </ul>
        <div v-if="isMobile" class="credit">
          created by:
          <a href="https://netrise.co.il" target="_blank">Netrise.co.il</a>
        </div>
      </nav>
    </transition>

    <div class="header__logo">
      <svg v-if="!isMobile" width="209" height="64" viewBox="0 0 209 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>לוגו וולטה סולאר</title>
        <path
          d="m18.664 18.62 12.977 19.013 1.006-1.508L20.676 18.62h-2.012zM11.42 18.62l16.599 24.245 1.006-1.409L13.432 18.62H11.42zM15.043 18.62l14.788 21.63 1.006-1.51-13.782-20.12h-2.012zM8 18.62l18.309 26.76.905-1.308L9.811 18.62H8z"
          fill="#0D47A1" />
        <path
          d="M33.954 18.62h-1.911l-4.93 7.143 1.006 1.509M41.197 18.62h-2.012l-8.45 12.374 1.005 1.509 9.457-13.883zM37.575 18.62h-2.012l-6.64 9.758 1.007 1.51 7.645-11.268zM33.452 35.018 44.62 18.62h-1.811L32.547 33.61l.905 1.408z"
          fill="#FBC02D" />
        <path
          d="M69.293 22.184c.705 0 .906.302.604.905l-6.64 18.108c-.2.604-.502.805-1.207.805h-1.509c-.704 0-1.006-.201-1.207-.704l-6.64-18.108c-.2-.604 0-.905.604-.905h1.409c1.106 0 1.508.2 1.71.805l4.124 11.97c.403 1.308.705 2.918.705 3.019h.2s.303-1.71.705-2.918l4.024-11.97c.201-.705.603-.806 1.71-.806l1.408-.2zM68.79 32.747c0-3.52 2.313-5.633 6.437-5.633 4.125 0 6.54 2.112 6.54 5.633v4.125c0 3.52-2.314 5.633-6.54 5.633-4.124 0-6.438-2.112-6.438-5.633v-4.125zm9.656 0c0-1.71-1.207-2.716-3.219-2.716-2.012 0-3.219 1.006-3.219 2.716v4.225c0 1.71 1.107 2.717 3.22 2.717 2.011 0 3.219-1.006 3.219-2.717v-4.225zM87.099 41.197c0 .604-.201.906-.805.906h-1.509c-.603 0-.804-.201-.804-.906V22.184c0-.603.2-.905.804-.905h1.51c.603 0 .804.201.804.905v19.013zM93.537 24.196c.704 0 .905.201.905.805v2.515h3.22c.502 0 .905.402.905.905v1.308c0 .603-.201.905-.906.905h-3.219v5.634c0 1.307.201 2.213.704 2.615.403.403 1.308.604 2.515.604.503 0 .906.402.906.905v1.409c0 .704-.201.905-.906.905-2.414.1-4.024-.302-5.03-1.207-1.006-.906-1.509-2.616-1.509-5.03v-5.734h-1.911c-.704 0-.805-.201-.805-.906V28.32c0-.503.403-.804.805-.804h2.012V25c0-.604.201-.805.905-.805h1.409zM105.509 26.913c4.124 0 6.136 2.012 6.136 5.935v7.444c0 1.006-.201 1.308-1.006 1.61-1.106.503-2.917.704-5.13.704-2.415 0-4.125-.402-5.03-1.107-1.006-.704-1.409-1.91-1.409-3.52 0-3.42 1.811-4.628 6.539-4.628.201 0 1.107.1 2.716.1v-.804c0-1.912-.804-2.817-2.917-2.817-1.408 0-2.414.503-3.018 1.408-.402.604-.604.704-1.207.403l-1.107-.503c-.603-.302-.804-.704-.503-1.308 1.006-1.911 3.018-2.917 5.936-2.917zm2.816 9.355c-2.012-.1-2.917-.1-3.018-.1-2.012 0-2.716.603-2.716 1.81 0 1.308.604 1.912 2.616 1.912 1.207 0 2.112-.1 2.817-.201.201-.1.301-.202.301-.403v-3.018zM126.634 21.681c3.923 0 6.035 1.308 7.343 4.225.302.604.101 1.006-.503 1.308l-1.509.704c-.603.201-.905.201-1.207-.503-.805-1.61-2.012-2.313-4.124-2.313-2.717 0-4.024.905-4.024 2.615-.202 1.51 1.509 2.113 2.917 2.415.905.2 2.917.402 3.923.603 1.107.201 2.716.805 3.521 1.61.906.804 1.509 2.213 1.509 4.024 0 3.822-2.917 6.237-7.947 6.237-4.225 0-6.539-1.51-7.746-4.628-.201-.704-.101-1.006.603-1.207l1.509-.604c.604-.2.906-.1 1.208.604.704 1.71 2.213 2.615 4.325 2.615 2.918 0 4.427-1.005 4.427-2.917 0-1.207-1.107-2.012-2.213-2.314-.604-.1-1.308-.2-2.214-.301-1.307-.101-1.81-.202-3.018-.503-1.207-.202-1.81-.604-2.716-1.107-1.308-.805-1.811-2.113-1.911-4.225.201-3.823 2.917-6.338 7.847-6.338zM135.688 32.747c0-3.52 2.313-5.633 6.438-5.633 4.124 0 6.539 2.112 6.539 5.633v4.125c0 3.52-2.314 5.633-6.539 5.633-4.125 0-6.438-2.112-6.438-5.633v-4.125zm9.858 0c0-1.71-1.207-2.716-3.219-2.716-2.012 0-3.219 1.006-3.219 2.716v4.225c0 1.71 1.106 2.717 3.219 2.717 2.113 0 3.219-1.006 3.219-2.717v-4.225zM154.099 41.197c0 .604-.201.906-.805.906h-1.509c-.603 0-.805-.201-.805-.906V22.184c0-.603.202-.905.805-.905h1.509c.604 0 .805.201.805.905v19.013zM162.145 26.913c4.125 0 6.137 2.012 6.137 5.935v7.444c0 1.006-.201 1.308-1.006 1.61-1.107.503-2.917.704-5.131.704-2.414 0-4.124-.402-5.03-1.107-.905-.704-1.408-1.91-1.408-3.52 0-3.42 1.811-4.628 6.539-4.628.201 0 1.107.1 2.716.1v-.804c0-1.912-.805-2.817-2.917-2.817-1.409 0-2.415.503-3.018 1.408-.403.604-.604.704-1.207.403l-1.107-.503c-.604-.302-.805-.704-.503-1.308 1.107-1.911 3.018-2.917 5.935-2.917zm2.817 9.355c-2.012-.1-2.917-.1-3.018-.1-2.012 0-2.716.603-2.716 1.81 0 1.308.604 1.912 2.616 1.912 1.207 0 2.112-.1 2.816-.201.202-.1.302-.202.302-.403v-3.018zM177.638 27.114c.603 0 .905.201.905.905v1.308c0 .603-.201.905-.805.905h-1.006c-1.006 0-1.911.1-2.615.302-.201 0-.302.1-.302.302v10.462a.902.902 0 0 1-.905.906h-1.61c-.604 0-.905-.202-.905-.906v-11.77c0-.905.201-1.207 1.106-1.61 1.409-.502 3.119-.804 5.231-.804h.906z"
          fill="#0D47A1" />
      </svg>

      <svg v-else width="40" height="30" viewBox="0 0 40 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M28.203 1.778h-2.087l-5.119 7.16.023.012 1.032 1.439M35.699 1.778h-2.087L24.766 14.16l1.043 1.456 9.89-13.84zM31.953 1.778h-2.092l-6.98 9.766 1.05 1.462 8.022-11.228zM27.588 18.095 39.246 1.777h-1.89L26.645 16.772l.945 1.323z"
          fill="#FBC02D" />
        <path
          d="m12.185 1.778 13.531 18.939 1.05-1.461L14.277 1.778h-2.093zM4.69 1.778 21.97 25.96l1.044-1.46L6.782 1.777H4.69zM8.44 1.778l15.403 21.56 1.044-1.46-14.36-20.1H8.44zM1.142 1.778l19.055 26.666.945-1.322L3.037 1.778H1.142z"
          fill="" class="change-fill" />
      </svg>

    </div>
  </header>
</template>

<script>
import { ref, toRef } from "vue";
import { useStore } from "vuex";
export default {
  name: "AppHeader",
  props: { bright: Boolean },

  setup(props) {
    const store = useStore();
    const steps = store.state.steps;
    const isMobile = toRef(store.getters, "isMobile");
    const representativeUrl = 'https://app.acuityscheduling.com/schedule.php?owner=25554738';

    let isMenuActive = ref(false);

    function toggleMenu() {
      isMenuActive.value = !isMenuActive.value;
    }

    function talkToRepresentative() {
      window.open(representativeUrl, "_blank");
    }

    function setStep(step, e) {
      e.preventDefault();
      if(!step.canAccess) return;

      store.commit("setStep", step.step);
      if (isMobile.value) {
        isMenuActive.value = false
        const offset = document.querySelector(`[data-step="${step.step}"]`).offsetTop - 60
        window.scrollTo({
          top: offset,
          behavior: 'smooth'
        })
      }
    }

    const openModal = (name) => store.commit('setModal', name)


    return { ...props, steps, setStep, isMobile, toggleMenu, isMenuActive, openModal, talkToRepresentative };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/scss/setup";

.header {
  display: flex;
  height: vw(64, 1920);
  padding: 0 vw(28, 1920);
  align-items: center;
  background-color: $light-bg;
  box-shadow: 0 4px 7px 0 rgba(0, 53, 138, 0.2);
  position: relative;
  z-index: 5;

  @include break($large) {
    height: tovw(64px);
    max-height: 9vh;
    padding: 0 tovw(28px);
  }

  @include break($small) {
    height: 60px;
    background-color: $primary;
    color: #fff;
    padding: 0 15px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    transition: background-color 180ms linear;
  }

  &.bright {
    @include break($small ) {
      background-color: #fff;
    }

    .open-menu svg {
      @include break($small ) {
        stroke: $primary;
      }
    }

    .change-fill {
      fill: $primary ;
    }
  }

  &__logo {
    margin-right: auto;

    @include break($large) {
      max-width: 160px;
    }

    @include break($medium) {
      max-width: 130px;
    }

    svg,
    img {
      max-width: 100%;
    }

    .change-fill {
      fill: #fff
    }
  }
}

.btn {
  margin-left: vw(10, 1920);

  @include break($large) {
    margin-left: tovw(10px);
  }

  @include break(991px) {
    //min-width: 120px;
  }
}

.nav {
  @include break(991px) {
    height: 100vh;
    background-color: $primary-light;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    padding-top: 100px;
  }

  &__top {
    display: none;

    @include break($small) {
      position: absolute;
      top: 0;
      display: flex;
      padding: 18px;
      width: 100%;
      justify-content: space-between;
    }
  }

  ul {
    display: flex;

    @include break(991px) {
      display: block;
    }
  }

  &__item {
    padding: 0 vw(18, 1920);
    position: relative;

    @include break($large) {
      padding: 0 vw(14);
    }

    @include break(991px) {
      text-align: center;
      margin-bottom: 30px;
    }

    &:not(:last-child) {
      &::after {
        content: ">";
        position: absolute;
        left: 0;
        transform: translateX(-50%);

        @include break(991px) {
          content: none;
        }
      }
    }
  }

  &__link {
    text-decoration: none;
    font-weight: 600;
    line-height: 1;
    font-size: vw(20, 1920);

    @include break($large) {
      font-size: vw(17);
      font-weight: 400;
    }

    @include break($small ) {
      font-size: 18px;
    }

    &.active {
      border-bottom: 2px solid $secondary;

      @include break(991px) {
        border-bottom: 0;
      }
    }
  }
}

.open-menu {
  display: none;

  @include break($small) {
    display: block;

  }

  svg {
    @include break($small ) {
      stroke: #fff;
      transition: all 180ms linear;
    }
  }

  margin-left: 30px;
}

.drop-enter-active,
.drop-leave-active {
  transition: all 220ms linear;
}

.drop-enter-from,
.drop-leave-to {
  transform: translateX(-100%);
}

.credit {
  position: absolute;
  bottom: 20px;
  left: 20px;
  color: #fff;
  z-index: 20;
  font-size: 15px;
}
</style>
